import {
  AppstoreAddOutlined,
  AppstoreOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  DollarCircleOutlined,
  EyeOutlined,
  LineChartOutlined,
  MobileOutlined,
  PictureOutlined,
  ProductOutlined,
  RedEnvelopeOutlined,
  ScheduleOutlined,
  StarOutlined,
  TagOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from '@ant-design/icons';
import React, { Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

import DashboardLayout, { RouteMeta } from '../app/components/dashboard-layout';
import Footer from '../app/components/footer';
import Header from '../app/components/header';
import Loader from '../loader/loader';
import { all_routes } from './all-routes';
import { PrivateRoute, PublicRoute } from './route-guards';
import { dashboardRoutes, publicRoutes, withoutHeaderRoutes } from './router-link';

const AllRoutes = () => {
  const routes = all_routes;
  const HeaderLayout = () => (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );

  const links: RouteMeta[] = [
    {
      path: routes.dashboard,
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      path: routes.users,
      icon: <UserOutlined />,
      label: 'Manage Users',
    },
    {
      path: routes.fees,
      icon: <TagOutlined />,
      label: 'Fees',
    },
    {
      path: '',
      icon: <ProductOutlined />,
      label: 'Inventory',
      children: [
        {
          path: routes.productCategories,
          icon: <AppstoreOutlined />,
          label: 'Categories',
        },
        {
          path: routes.products,
          icon: <AppstoreAddOutlined />,
          label: 'Products',
        },
        {
          path: routes.sales,
          icon: <LineChartOutlined />,
          label: 'Sales',
        },
      ],
    },
    {
      path: '',
      icon: <EyeOutlined />,
      label: 'Public',
      children: [
        {
          path: routes.contacts,
          icon: <RedEnvelopeOutlined />,
          label: 'Messages',
        },
        {
          path: routes.dashboardServices,
          icon: <CustomerServiceOutlined />,
          label: 'Services',
        },
        {
          path: routes.dashboardInstructors,
          icon: <UsergroupAddOutlined />,
          label: 'Instructors',
        },
        {
          path: routes.dashboardFeatures,
          icon: <MobileOutlined />,
          label: 'Features',
        },
        {
          path: routes.dashboardTestimonials,
          icon: <StarOutlined />,
          label: 'Testimonials',
        },
        {
          path: routes.prices,
          icon: <DollarCircleOutlined />,
          label: 'Pricing',
        },
        {
          path: routes.dashboardEvents,
          icon: <ScheduleOutlined />,
          label: 'Events',
        },
        {
          path: routes.dashboardGallery,
          icon: <PictureOutlined />,
          label: 'Gallery',
        },
      ],
    },
  ];

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route element={<HeaderLayout />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        {/* Protected dashboard routes */}
        <Route element={<PrivateRoute />}>
          <Route element={<DashboardLayout routes={links} />}>
            {dashboardRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>
        </Route>
        {/* Auth pages (login, register, etc.) - only for unauthenticated users */}
        <Route element={<PublicRoute />}>
          {withoutHeaderRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
};
export default AllRoutes;
